const UserPickStructure = {
  userId: "", // Unique User ID
  userUUID: "",
  userName: "",
  profileImage: "",
  lastUpdatedOn: "",
  location: "",
  createdOn: "",
  lastActive: "",
  status: "",
  nBlueTickFollowing: "",
  feeds: [
    {
      userId: "",
      userUUID: "",
      userImageUrl: "",
      BlueTickStatus: "",
      profile: "",
      location: "",
      posts: [
      {
        postId: "", // Unique Post ID
        descriptions: "",
        timestamp: "", // ISO Date-Time String (e.g., "2025-03-03T12:00:00Z")
        location: "", // Location of the post
        nlikes: 0, // Number of likes
        medias: [
        {
          mediatype: "",
          mediaurl: "",
          nlikes: 0, // Number of likes
          comments: [
          {
            userId: "", // User who commented
            comment: "", // Comment text
            timestamp: "", // Comment time
            location: "", // Comment location (optional)
          },
          ],
          nshares: 0, // Number of times shared
          nsuggests: 0,
        }
        ],
        comments: [
        {
          userId: "", // User who commented
          comment: "", // Comment text
          timestamp: "", // Comment time
          location: "", // Comment location (optional)
        },
      ],
      nshares: 0, // Number of times shared
      }]
    },
  ],
};

export default UserPickStructure;
